import axios from 'axios';
import { API_BASE_URL } from '../config';

// Trailing slash temizle
const BASE = API_BASE_URL.replace(/\/+$/, '');

export const http = axios.create({
  baseURL: BASE
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err) => Promise.reject(err)
);

// Küçük yardımcı: endpoint başındaki '/' yi kaldır
export const ep = (p) => p.replace(/^\/+/, '');
